import { render, staticRenderFns } from "./afterSaleProcess.vue?vue&type=template&id=6190a890&scoped=true"
import script from "./afterSaleProcess.vue?vue&type=script&lang=js"
export * from "./afterSaleProcess.vue?vue&type=script&lang=js"
import style0 from "./afterSaleProcess.vue?vue&type=style&index=0&id=6190a890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6190a890",
  null
  
)

export default component.exports